import OpenSurgicalOrderLayout from 'presentation/doctor/layouts/AddSurgicalOrderNew/OpenSurgicalOrder'
import React from 'react'

const OpenSurgicalOrder = () => <OpenSurgicalOrderLayout />

export default OpenSurgicalOrder
